

import { useState, useEffect } from "react"
import axios from "axios"
import { useNavigate } from "react-router-dom"
import SelectBox from "./Select"
import { toast } from "react-toastify"
import Swal from "sweetalert2"

const SellerSelection = ({
  onSellerSelect,
  loadingCallback,
  className = "",
  placeholder = "Select Seller",
  transparentBorder = false,
}) => {
  const [searchKeyword, setSearchKeyword] = useState("")
  const [selectedSeller, setSelectedSeller] = useState(null)
  const [sellerList, setSellerList] = useState([])
  const navigate = useNavigate()
  const token = localStorage.getItem("token")

  const getSellerListData = async (searchKeyword = "") => {
    if (loadingCallback) loadingCallback(true)

    const page = 1
    const perPage = 20

    try {
      let response

      if (searchKeyword === "") {
        // Get all sellers
        response = await axios.get(`${process.env.REACT_APP_API_URL}employee`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
      } else {
        // Search sellers
        response = await axios.post(
          `${process.env.REACT_APP_API_URL}search-employee?page=${page}&limit=${perPage}`,
          { keyword: searchKeyword },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        )
      }

      if (loadingCallback) loadingCallback(false)

      if (response.status === 200) {
        const sellers = searchKeyword === "" ? response.data.data.data : response.data.data

        if (sellers && sellers.length > 0) {
          const sellerOptions = sellers.map((seller) => ({
            id: seller.id,
            employee_type: seller.employee_type,
            name: seller.name,
            email: seller.email,
            country_code: seller.country_code,
            mobile_number: seller.mobile_number,
            address: seller.address,
            country: seller.country,
            district: seller.district,
            city: seller.city,
            zipcode: seller.zipcode,
            nid: seller.nid,
            joining_date: seller.joining_date,
            blood_group_id: seller.blood_group_id,
            emergency_contact_name: seller.emergency_contact_name,
            emergency_country_code: seller.emergency_country_code,
            emergency_mobile_numbers: seller.emergency_mobile_numbers,
            relation_with: seller.relation_with,
            status: seller.status,
          }))
          setSellerList(sellerOptions)
        } else {
          setSellerList([])
        }
      } else {
        console.log("Data Not Found!")
        setSellerList([])
      }
    } catch (error) {
      if (loadingCallback) loadingCallback(false)
      console.log(error)

      if (error?.response?.status === 401) {
        localStorage.clear()
        localStorage.setItem("token", false)
        localStorage.setItem("isPinVerify", false)
        navigate("/login")
      }
    }
  }

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      getSellerListData(searchKeyword)
    }, 700)

    return () => clearTimeout(debounceTimeout)
  }, [searchKeyword])

  const handleSellerSelect = (selectedOption) => {
    const { value } = selectedOption

    if (value === "") {
      setSelectedSeller(null)
      return
    }

    const sellerId = Number.parseInt(value)
    const selectedSellerData = sellerList.find((seller) => seller.id === sellerId)

    if (selectedSellerData) {
      setSelectedSeller(selectedSellerData)

      const sellerData = {
        id: selectedSellerData.id,
        employee_type: selectedSellerData.employee_type || "Full Time",
        name: selectedSellerData.name,
        email: selectedSellerData.email,
        country_code: selectedSellerData.country_code,
        mobile_number: selectedSellerData.mobile_number,
        address: selectedSellerData.address,
        country: selectedSellerData.country ? Number(selectedSellerData.country) : null,
        district: selectedSellerData.district ? Number(selectedSellerData.district) : null,
        city: selectedSellerData.city ? Number(selectedSellerData.city) : null,
        zipcode: selectedSellerData.zipcode ? Number(selectedSellerData.zipcode) : null,
        nid: selectedSellerData.nid ? Number(selectedSellerData.nid) : null,
        joining_date: selectedSellerData.joining_date,
        blood_group_id: selectedSellerData.blood_group_id,
        emergency_contact_name: selectedSellerData.emergency_contact_name,
        emergency_country_code: selectedSellerData.emergency_country_code,
        emergency_mobile_numbers: selectedSellerData.emergency_mobile_numbers,
        relation_with: selectedSellerData.relation_with,
        status: selectedSellerData.status || 1,
      }

      // Call the callback function to notify parent component
      if (onSellerSelect) {
        onSellerSelect(sellerData)
      }

      // Show success message
      // FlashMessage("Seller added successfully", "success")
      // toast.success("Seller added successfully")
      Swal.fire({
  title: "Success",
  text: "Seller added successfully",
  icon: "success",
  timer: 500,
  showConfirmButton: false // hides the "OK" button
});
    }
  }

  const handleInputChange = (inputValue) => {
    clearTimeout(window.debounceTimeout)
    window.debounceTimeout = setTimeout(() => {
      setSearchKeyword(inputValue)
    }, 1000)
  }

  return (
    <div className={`seller-selection ${className}`}>
      <SelectBox
        name="seller_id"
        options={sellerList}
        value={selectedSeller ? selectedSeller.id : ""}
        onChange={handleSellerSelect}
        transparentBorder={transparentBorder}
        onInputChangeData={handleInputChange}
        searchQuery={searchKeyword}
        placeholder={placeholder}
        className="w-full rounded-[15px] bg-white"
        label="Select Seller"
      />
    </div>
  )
}

export default SellerSelection
